import {getUntreatedWarningCount, selectWarningRecordType, confirmWarningRecord, getUntreatedWarningRecordByPage, selectConfigRecord} from '@/api/WarningRecord'
import {warningMenu} from "@/api/customerRoleMenu"
import {reSendCmd} from "@/api/Meter"
import { getChargingByCustomerId } from '@/api/ChargingPrice'

const warningRecord = {
  actions: {
    /**
     * 未处理报警查询
     * @param customerId
     */
    getUntreatedWarningCount({commit}, id) {
      return new Promise((resolve, reject) => {
        getUntreatedWarningCount(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    selectWarningRecordType({commit}, id) {
      return new Promise((resolve, reject) => {
        selectWarningRecordType(id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    confirmWarningRecord({commit}, warningRecord) {
      return new Promise((resolve, reject) => {
        confirmWarningRecord(warningRecord).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    warningMenu({commit}, map) {
      return new Promise((resolve, reject) => {
        warningMenu(map).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getUntreatedWarningRecordByPage({commit}, data) {
      return new Promise((resolve, reject) => {
        getUntreatedWarningRecordByPage(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    selectConfigRecord({commit}, data) {
      return new Promise((resolve, reject) => {
        selectConfigRecord(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    reSendCmd({commit}, data) {
      return new Promise((resolve, reject) => {
        reSendCmd(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    getChargePrice({commit}, data) {
      return new Promise((resolve, reject) => {
        getChargingByCustomerId(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }


}
export default warningRecord

